
import $store from 'stores/integrations'
import {getIntegrations} from 'consts/integrations.js'

export default {
  data() {
    return {
    }
  },
  computed: {
    loading() {
      return $store.loading
    },
    integrations() {
      const result = []
      const integrations = getIntegrations()
      for(let item of integrations) {
        result.push({
          ...item,
          store: $store.getIntegration(item.type) || {enabled: false, connected: false, type: item.type}
        })
      }
      return result
    },
  },
  async mounted() {
    if (!$store.loading) await $store.load()
  },
  methods: {
    async onConnect(type) {
      await $store.connect(type)
    },
    async onDisconnect(type) {
      await $store.delete(type)
    },
    async onEnable(type, enabled) {
      $store.enable(type, enabled)
    },
    handleToggleChange(model, type, item) {
      const enabled = model?.value ?? model
      if (enabled) {
        this.onDisconnect(type)
      } else {
        if (!item.store.connected) {
          this.onConnect(type)
        } else {
          this.onDisconnect(type)
        }
      }
    }
  }
}
